import { ChangeDetectorRef, Directive, OnDestroy, Optional } from '@angular/core';
import { AccountEditComponentDef } from '@df/account/account-edit.component.def';
import { ModalRef } from '@df/ui/modal/modal-ref';

@Directive({})
export abstract class AbstractEditFormComponent extends AccountEditComponentDef implements OnDestroy {
    constructor(ref: ChangeDetectorRef, @Optional() private modalRef: ModalRef<AbstractEditFormComponent>) {
        super(ref);
    }

    close() {
        if (this.modalRef) {
            this.modalRef.close();
        } else {
            this.router.navigateByUrl('/account/edit');
        }
    }

    override onSubmitSuccess() {
        this.close();
        super.onSubmitSuccess();
    }
}
